import { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { getTotalNxacList } from "src/service/pay";
import styles from "./index.module.scss";
import { customAlert } from "src/utils/alert";
import { UseFormSetValue } from "react-hook-form";
import { useGetTotalNxacList } from "src/hooks/api/nxac/useGetTotalNxacList";
import { TotalNxacType } from "src/service/types/pay.type";
import { useTranslation } from "react-i18next";

interface IUpcListProps {
  productInfo: any;
  setValue?: UseFormSetValue<any>;
}

const UpcList = ({ productInfo, setValue }: IUpcListProps) => {
  const [applicationList, setApplicationList] = useState<any>([]);
  const [showExtDetail, setShowExtDetail] = useState<boolean>(false);
  const [showExtDetailUid, setShowExtDetailUid] = useState<string>("");
  const [selectAppList, setSelectAppList] = useState<string[]>([]);
  const { t } = useTranslation();
  useEffect(() => {
    getTotalNxacList().then((result) => {
      setApplicationList(result);
    });
  }, []);
  const { isLoadingNxacList, nxacList } = useGetTotalNxacList({});

  useEffect(() => {
    if (setValue) {
      let filterResult: any;
      if (nxacList !== undefined && selectAppList !== undefined) {
        const tempNxacList: TotalNxacType[] = [...nxacList];
        const filterNxacList = tempNxacList.filter((data: any) =>
          selectAppList?.includes(data.nxacAppUid)
        );
        if (filterNxacList) {
          filterResult = filterNxacList?.map((data) => {
            const { applicationName, nxacAppUid } = data;
            return {
              id: nxacAppUid,
              name: applicationName,
            };
          });
        }
      }
      setValue("issueAppList", filterResult);
    }
  }, [selectAppList]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.name === "selectAppList") {
      if (selectAppList.indexOf(e.target.value as never) !== -1) {
        setSelectAppList((prev) => prev.filter((el) => el !== e.target.value));
      } else {
        setSelectAppList((prev) => {
          if (
            prev.length === productInfo.upcCnt &&
            productInfo.name !== "Premium"
          ) {
            customAlert({
              html: `${t("admin.upc.site.upcSelectLimit")}`,
            });
            return prev;
          } else return prev.concat(e.target.value as never);
        });
      }
    }
  };

  const openExtDetailModal = (e: any, uid: any) => {
    e.preventDefault();
    setShowExtDetail(true);
    setShowExtDetailUid(uid);
  };

  const hideExtDetailModal = () => {
    setShowExtDetail(false);
  };

  return (
    <>
      {productInfo?.upcCnt > 0 && (
        <div className={styles.upcContainer}>
          <span className={styles.formItemTitle}>
            {t("cashStatus.chooseApp")}
          </span>
          <div className={styles.selectedAppTitle}>
            {t("common.selected")}
            <span className={styles.selectedAppCount}>
              {selectAppList.length}
            </span>{" "}
            {t("common.items")}
            {/* 선택된 애플리케이션 표시
          {selectAppList.length > 0 && (
            <div className={styles.selectedApplications}>
              <div className={styles.selectedTitle}>
                {t("admin.upc.site.selectedApp")}:
              </div>
              <div className={styles.selectedList}>
                {applicationList
                  .filter((item: any) =>
                    selectAppList.includes(item.nxacAppUid)
                  )
                  .map((item: any, index: number) => (
                    <div key={item.nxacAppUid} className={styles.selectedItem}>
                      - {item.applicationName}
                    </div>
                  ))}
              </div>
            </div>
          )} */}
          </div>

          <div className={styles.selectApplication}>
            {applicationList.length > 0 &&
              applicationList.map((item: any, index: number) => {
                return (
                  <div key={item.nxacAppUid} className={styles.applicationItem}>
                    <div className={styles.checkboxGroup}>
                      <input
                        type="checkbox"
                        name="selectAppList"
                        id={"selectAppList_" + item.nxacAppUid}
                        value={item.nxacAppUid}
                        checked={selectAppList.indexOf(item.nxacAppUid) !== -1}
                        onChange={handleChange}
                      />
                      <label
                        className={styles.checkbox}
                        htmlFor={"selectAppList_" + item.nxacAppUid}
                      />
                      <span
                        className={`${styles.applicationName}`}
                        title={item.applicationName}
                        onClick={() => {
                          // 체크박스 상태를 토글하는 synthetic event 생성
                          const syntheticEvent = {
                            target: {
                              name: "selectAppList",
                              value: item.nxacAppUid,
                              checked:
                                selectAppList.indexOf(item.nxacAppUid) === -1, // 현재 상태의 반대로 설정
                            },
                          } as React.ChangeEvent<HTMLInputElement>;
                          handleChange(syntheticEvent);
                        }}
                      >
                        {item.applicationName}
                      </span>
                    </div>

                    <button
                      onClick={(e) => openExtDetailModal(e, item.nxacAppUid)}
                      className={styles.moreButton}
                    >
                      {t("common.more")}
                    </button>
                  </div>
                );
              })}

            {selectAppList && (
              <input className={styles.hiddenInput} value={selectAppList} />
            )}
          </div>

          {/* <hr className={styles.separator} /> */}
        </div>
      )}

      {showExtDetail && (
        <Modal
          show={showExtDetail}
          style={{ opacity: 1 }}
          className="applicationModal"
          animation={false}
          onHide={() => hideExtDetailModal()}
        >
          <Modal.Dialog style={{ margin: 0, width: 840 }}>
            <Modal.Header>
              <div className="header">
                <h3>{t("admin.upc.site.applicationModal")}</h3>
                <div className="exit">
                  <a onClick={() => hideExtDetailModal()}>
                    <i className="icon_cancel" />
                  </a>
                </div>
              </div>
            </Modal.Header>
            <Modal.Body style={{ width: "100%" }}>
              {/* {applicationList.map(item => ( */}

              {applicationList.map((item: any) =>
                item.nxacAppUid === showExtDetailUid ? (
                  <table>
                    <colgroup>
                      <col width="10%" />
                      <col width="20%" />
                      <col width="70%" />
                    </colgroup>
                    <tr>
                      <td colSpan={2}>
                        {t("admin.upc.site.applicationModal")}
                      </td>
                      <td
                        colSpan={2}
                        className="title"
                        title={item.applicationName}
                      >
                        {item.applicationName}
                      </td>
                    </tr>
                    <tr>
                      <td />
                      <td>{t("admin.upc.site.process")}</td>
                      <td>{t("admin.upc.site.extension")}</td>
                    </tr>
                    {item.processList.map((item1: any) => (
                      <tr>
                        <td />
                        <td>
                          <span
                            className="processName"
                            title={item1.processName}
                          >
                            {item1.processName}
                          </span>
                        </td>
                        <td>
                          <span className="upc" title={item1.nxacExt}>
                            {item1.nxacExt}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </table>
                ) : (
                  ""
                )
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                // className="btn btn-green"
                className={styles.btn}
                onClick={() => hideExtDetailModal()}
              >
                {t("common.okBtn")}
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </Modal>
      )}
    </>
  );
};

export default UpcList;
